import React from 'react';
import { StyledCookies } from './styles';

class Cookies extends React.Component {
  render() {
    return (
      <StyledCookies>
        <h3>Necessary</h3>
        <table>
          <thead>
            <tr>
              <th width="20%">Name</th>
              <th width="20%">Domain</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>intercom-state</td>
              <td>affiliateblockparty.com</td>
              <td>Allows the website to recoqnise the visitor, in order to optimize the chat-box functionality.</td>
            </tr>
          </tbody>
        </table>
        <h3>Statistics</h3>
        <table>
          <thead>
            <tr>
              <th width="20%">Name</th>
              <th width="20%">Domain</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>_ga</td>
              <td>affiliateblockparty.com</td>
              <td>Registers a unique ID that is used to generate statistical data on how the visitor uses the website.</td>
            </tr>
            <tr>
              <td>_gat</td>
              <td>affiliateblockparty.com</td>
              <td>Used by Google Analytics to throttle request rate</td>
            </tr>
            <tr>
              <td>_gid</td>
              <td>affiliateblockparty.com</td>
              <td>Registers a unique ID that is used to generate statistical data on how the visitor uses the website.</td>
            </tr>
          </tbody>
        </table>
        <h3>Marketing</h3>
        <table>
          <thead>
            <tr>
              <th width="20%">Name</th>
              <th width="20%">Domain</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>_hjIncludedInSample</td>
              <td>affiliateblockparty.com</td>
              <td>Determines if the user&apos;s navigation should be registered in a certain statistical place holder.</td>
            </tr>
          </tbody>
        </table>
      </StyledCookies>
    );
  }
}

export default Cookies;



// WEBPACK FOOTER //
// ./src/containers/CookieDeclaration/Cookies.js